module.exports = __webpack_public_path__ + "img/quotes-2.041356ab.webp";